"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MASK_CHARACTER = exports.TextFieldType = void 0;
var TextFieldType;
(function (TextFieldType) {
    TextFieldType["DATE"] = "date";
    TextFieldType["EMAIL"] = "email";
    TextFieldType["HIDDEN"] = "hidden";
    TextFieldType["INTEGER"] = "integer";
    TextFieldType["NUMBER"] = "number";
    TextFieldType["NUMERIC_PASSWORD"] = "numeric";
    TextFieldType["PASSWORD"] = "password";
    TextFieldType["TEL"] = "tel";
    TextFieldType["TEXT"] = "text";
})(TextFieldType = exports.TextFieldType || (exports.TextFieldType = {}));
var MASK_CHARACTER;
(function (MASK_CHARACTER) {
    MASK_CHARACTER["DEFAULT"] = "\u2022";
})(MASK_CHARACTER = exports.MASK_CHARACTER || (exports.MASK_CHARACTER = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/TextField/TextFieldProps.js
// module id = 188
// module chunks = 8